import React, { useState, useEffect } from 'react';
import './projects.css';
import Navbar from '../../navbar/navbar';
import Footer from '../../footer/footer';
import attentionGrabberImage1 from '../../../assets/images/ecologo.webp';
import attentionGrabberImage2 from '../../../assets/images/ecologo2.webp';
import yewImage1 from '../../../assets/images/IMG_2185 (1).jpg';
import yewImage2 from '../../../assets/images/IMG_1972 (1).jpg';
import yewImage3 from '../../../assets/images/IMG_3708 (1).jpg';
import yewImage4 from '../../../assets/images/IMG_2044 (1).jpg';
import yewImage18 from '../../../assets/images/IMG_2078 (1).jpg';
import yewImage19 from '../../../assets/images/IMG_2078 (1).jpg';
import yewImage20 from '../../../assets/images/IMG_2117 (1).jpg';
import yewImage21 from '../../../assets/images/IMG_2159 (1).jpg';
import yewImage5 from '../../../assets/images/IMG_2174 (1).jpg';
import yewImage6 from '../../../assets/images/IMG_3539 (1).jpg';
import yewImage7 from '../../../assets/images/IMG_2213 (1).jpg';
import yewImage8 from '../../../assets/images/IMG_2235-2 (1).jpg';
import yewImage9 from '../../../assets/images/IMG_2241-2 (1).jpg';
import yewImage10 from '../../../assets/images/IMG_2245-2 (1).jpg';
import yewImage11 from '../../../assets/images/IMG_2253-2 (1).jpg';
import yewImage12 from '../../../assets/images/IMG_2306-2 (1).jpg';
import yewImage13 from '../../../assets/images/IMG_2397-2 (1).jpg';
import GGDImage11 from '../../../assets/images/1717936595766-ggd1.webp';
import GGDImage12 from '../../../assets/images/1717936604753-ggd4.webp';
import GGDImage13 from '../../../assets/images/1717936605183-ggd2.webp';
import GGDImage14 from '../../../assets/images/20240607_124510.webp';
import GGDImage15 from '../../../assets/images/20240607_132003.webp';
import GGDImage16 from '../../../assets/images/IMG-20240607-WA0100.webp';
import GGDImage17 from '../../../assets/images/IMG-20240608-WA0107.webp';
import GGDImage18 from '../../../assets/images/Screenshot_20240607_200100_WhatsApp_1_cropped.webp';
import GGDImage19 from '../../../assets/images/IMG-20240607-WA0076.webp';
import divineImage1 from '../../../assets/images/1000143128.webp';
import divineImage2 from '../../../assets/images/1000143167.webp';
import divineImage3 from '../../../assets/images/1000143168.webp';
import divineImage4 from '../../../assets/images/1000143171.webp';
import divineImage6 from '../../../assets/images/1000143174.webp';
import divineImage7 from '../../../assets/images/1000143188.webp';
import divineImage8 from '../../../assets/images/1000143195.webp';
import divineImage9 from '../../../assets/images/1000143196.webp';
import divineImage10 from '../../../assets/images/1000143197.webp';
import divineImage12 from '../../../assets/images/1000143216.webp';
import divineImage13 from '../../../assets/images/1000143218.webp';
import divineImage14 from '../../../assets/images/1000143225.webp';
import divineImage15 from '../../../assets/images/1000143256.webp';
import divineImage16 from '../../../assets/images/IMG_6872-2.webp';
import divineImage17 from '../../../assets/images/IMG_6881-2.webp';
import divineImage18 from '../../../assets/images/IMG_6888-2.webp';
import divineImage19 from '../../../assets/images/IMG_6876-2.webp';
import divineImage5 from '../../../assets/images/IMG_6996-2.webp';
import tamaleImage1 from '../../../assets/images/IMG-20240719-WA0034(2).jpg';
import tamaleImage2 from '../../../assets/images/IMG-20240719-WA0093(2).jpg';
import tamaleImage3 from '../../../assets/images/IMG-20240719-WA0013(3).jpg';
import absaxImage1 from '../../../assets/images/IMG_8549.jpg';
import absaxImage2 from '../../../assets/images/IMG_8364.jpg';
import absaxImage3 from '../../../assets/images/IMG_8446.jpg';
import absaxImage4 from '../../../assets/images/IMG_8252.jpg';
import absaxImage5 from '../../../assets/images/IMG_8627.jpg';
import absaxImage6 from '../../../assets/images/IMG_8274.jpg';
import absaxImage7 from '../../../assets/images/IMG_8292.jpg';
import absaxImage8 from '../../../assets/images/IMG_8321.jpg';
import absaxImage9 from '../../../assets/images/IMG_8356.jpg';
import absaxImage10 from '../../../assets/images/IMG_8592.jpg';
import absaxImage11 from '../../../assets/images/IMG_8390.jpg';
import absaxImage12 from '../../../assets/images/IMG_8395.jpg';
import absaxImage13 from '../../../assets/images/IMG_8426.jpg';
import absaxImage14 from '../../../assets/images/IMG_8476.jpg';
import absaxImage15 from '../../../assets/images/IMG_8482.jpg';
import absaxImage17 from '../../../assets/images/IMG_8532.jpg';
import absaxImage18 from '../../../assets/images/IMG_8538.jpg';
import absaxImage19 from '../../../assets/images/IMG_8575.jpg';
import agrivisionImage1 from '../../../assets/images/IMG-20250316-WA0253.jpg';
import agrivisionImage2 from '../../../assets/images/IMG-20240921-WA0009.jpg';
import agrivisionImage3 from '../../../assets/images/IMG-20240921-WA0030.jpg';
import agrivisionImage4 from '../../../assets/images/IMG-20240921-WA0041.jpg';
import agrivisionImage5 from '../../../assets/images/IMG-20250219-WA0009.jpg';
import agrivisionImage6 from '../../../assets/images/IMG-20250316-WA0253.jpg';
import agrivisionImage7 from '../../../assets/images/IMG-20250316-WA0241.jpg';
import agrivisionImage8 from '../../../assets/images/IMG-20250316-WA0167.jpg';
import agrivisionImage9 from '../../../assets/images/IMG-20250316-WA0147.jpg';
import atiwaImage1 from '../../../assets/images/atiwa1.jpg';
import atiwaImage2 from '../../../assets/images/atiwa2.jpg';
import atiwaImage3 from '../../../assets/images/atiwa3.jpg';
import atiwaImage4 from '../../../assets/images/atiwa 4.jpg';
import ashantiImage1 from '../../../assets/images/IMG-20241010-WA0005.jpg';
import ashantiImage2 from '../../../assets/images/IMG-20241007-WA0063(1).jpg';
import ashantiImage3 from '../../../assets/images/IMG-20241010-WA0046.jpg';
import ashantiImage4 from '../../../assets/images/IMG-20241010-WA0006.jpg';
import ashantiImage5 from '../../../assets/images/IMG-20241010-WA0007.jpg';
import ashantiImage6 from '../../../assets/images/IMG-20241010-WA0010.jpg';
import ashantiImage7 from '../../../assets/images/IMG-20241010-WA0013(1).jpg';
import { Helmet } from 'react-helmet';


// --- Reusable Gallery Component ---
const Gallery = ({ images }) => {
    const [currentIndex, setCurrentIndex] = useState(0);

    const nextImage = () => setCurrentIndex((prev) => (prev + 1) % images.length);
    const prevImage = () => setCurrentIndex((prev) => (prev - 1 + images.length) % images.length);

    return (
        <div className="py-6 lg:w-3/5 mx-auto">
            <div className="gallery-container relative mb-12">
                <button
                    className="gallery-btn prev"
                    onClick={prevImage}
                    aria-label="Previous Image"
                >
                    &#10094;
                </button>
                <img
                    src={images[currentIndex]}
                    alt={`Project image ${currentIndex + 1}`}
                    className="gallery-img rounded-md shadow-lg"
                />
                <button
                    className="gallery-btn next"
                    onClick={nextImage}
                    aria-label="Next Image"
                >
                    &#10095;
                </button>
            </div>
        </div>
    );
};

// --- Projects Data ---
const projectsData = [
    {
        id: 'absax',
        title: 'AbsaxDziko Climate Innovation Workshop',
        summary:
            'Absa Bank Ghana, in collaboration with DZIKO CENTRE FOR CLIMATE JUSTICE, hosted a hands-on workshop at Accra Technical University equipping young tech minds to tackle climate challenges through innovation.',
        details: (
            <>
                <p>
                    The workshop engaged 100 students in Computer Science, Cybersecurity,
                    and Applied Informatics, exploring the theme: “Tech x Climate Innovation:
                    Turning Problems into Climate Solutions.”
                </p>
                <p>
                    Highlights included:
                    <ul>
                        <li>A systems introduction to plastic waste, e-waste, smart farming, and clean energy</li>
                        <li>A showcase of Dziko’s biomass pellet innovation</li>
                        <li>Demonstrations of upcycled products and hands-on prototyping</li>
                        <li>Reflective discussions on how youth can build scalable solutions</li>
                    </ul>
                </p>
                <p>
                    From concept to community impact, the message was clear: climate action must be
                    collaborative, tech-driven, and youth-led.
                </p>
                <p>
                    Kudos to Absa Bank Ghana for investing in climate-smart innovation and Dziko Centre
                    for Climate Justice for continuously building spaces for youth leadership toward a regenerative future.
                </p>
                </>
        ),
        galleryImages: [absaxImage1, absaxImage2, absaxImage3, absaxImage4, absaxImage5, absaxImage6, absaxImage7, absaxImage8, absaxImage9, absaxImage10,absaxImage11,absaxImage12,absaxImage13,absaxImage14,absaxImage15,absaxImage17,absaxImage18,absaxImage19
        ],
    },

    {
        id: 'agrivision',
        title: 'Dziko Agrivision Project',
        summary:
            'Promoting climate resilient farming in Ghana, starting in Tilli Community, Upper East. We have built 3 reservoirs with plans to solar power them and work with refugees and youth to boost agriculture.',
        details: (
            <>
                <p>
                    This project focuses on ensuring constant water supply through reservoirs and sustainable farming practices.
                    By engaging refugees and local youth, we aim to revitalize agriculture and attract more young people to the sector.
                </p>
            </>
        ),
        galleryImages: [agrivisionImage1, agrivisionImage2, agrivisionImage3, agrivisionImage4, agrivisionImage5, agrivisionImage6, agrivisionImage7, agrivisionImage8, agrivisionImage9],
    },

    {
        id: 'atiwa',
        title: 'Dziko Donates to Atiwa Community Hospital',
        summary:
            'In partnership with Ghana Healthcare Volunteers of Georgia Inc, Dziko Centre donated trash cans and biohazard bins to improve waste management at Atiwa Community Hospital, Eastern Region.',
        details: (
            <>
                <p>
                    This donation enhances healthcare and environmental protection by supporting safe waste disposal, disease prevention, and sustainable waste management.
                </p>
                <p>
                    We are proud to partner with GHANA HEALTHCARE VOLUNTEERS OF GEORGIA INC on this impactful initiative.
                </p>
            </>
        ),
        galleryImages: [atiwaImage1, atiwaImage2, atiwaImage3, atiwaImage4],
    },



    
    {
        id: 'ashanti',
        title: 'Ashanti Regional Visit',
        summary:
            'Our executives and volunteers toured the biomass pellet factory in Kumasi and discussed promoting renewable energy and climate-smart farming with key partners.',
        details: (
            <>
                <p>
                    Joined by Mr Patel, Executive Director and Director of JSK Renewable Energy Ltd, we brainstormed upcoming projects including:
                    <ul>
                        <li>Promoting sustainable cooking and renewable fuel sources</li>
                        <li>Supporting agricultural initiatives with organic fertilizers</li>
                    </ul>
                </p>
                <p>
                    Exciting times ahead as we prepare to lead education and advocacy efforts in the coming months!
                </p>
            </>
        ),
        galleryImages: [ashantiImage1, ashantiImage2, ashantiImage3, ashantiImage4, ashantiImage5, ashantiImage6, ashantiImage7],
    },


    {
        id: 'tamale',
        title: 'Northern Regional Visit',
        summary:
            'Our executives and volunteers in the North, discussed promoting renewable energy and climate-smart farming with key partners.',
        details: (
            <>
                <p className="mb-2 sm:max-w-50 mx-5 px-0">
                    From July 18th to 20th, 2024, leaders from Dziko Centre for Climate Justice in Accra embarked on a pivotal visit to Tamale in the Northern Region. This journey was focused on conducting community assessments, building new partnerships, and strengthening our volunteer network.
                </p>
                <p className="mb-2 sm:max-w-50 mx-5 px-0">
                    During the visit, we had the honour of engaging with the chief and residents of the Taha community, discussing the pressing impacts of climate change and exploring ways to address harmful environmental practices. These conversations underscored our collective commitment to sustainable development and environmental stewardship.
                </p>
                <p className="mb-2 sm:max-w-50 mx-5 px-0">
                    Our vibrant volunteers shared inspiring ideas and plans for future projects aligned with Dziko’s mission to promote sustainability and combat climate change.
                </p>
                <p className="mb-2 sm:max-w-50 mx-5 px-0">
                    Additionally, we explored local recreational sites, reaffirming our dedication to environmental conservation and eco-friendly tourism.
                </p>
                <p className="mb-12 sm:max-w-50 mx-5 px-0">
                    This visit deepened our resolve and broadened our perspective as we continue advancing climate justice across Ghana.
                </p>

            </>
        ),
        galleryImages: [tamaleImage1, tamaleImage2, tamaleImage3],
    },

    
      {  id: 'yew-upcycling',
        title: 'Young Eco-Warriors Upcycling Project',
        summary:
            "Equipping youth in Pokuase with skills to transform plastic waste into valuable items, promoting environmental sustainability and entrepreneurship.",
        details: (
            <>
                <p>
                    The upcycling project, a proud initiative under the YALI Community Engagement Fund 2024, was successfully executed in Pokuase, Ghana. The primary goal of this project was to equip 50 young individuals with the skills to address the plastic waste crisis while creating sustainable livelihood opportunities. By training participants to transform single-use plastics into valuable items like tote bags and aprons, the project sought to promote environmental sustainability and entrepreneurship.</p>

                    <p>The program spanned a two week period from 4th to 15th November, 2024. The training sessions were held at MLC Fashion, Pokuase from 10:00 AM to 1:00 PM daily, providing a structured and practical learning environment. Participants were introduced to innovative upcycling techniques and guided through the process of creating functional and marketable products. This hands-on approach ensured that the trainees could immediately apply their new skills in real-world contexts.</p>

                    <p>The closing ceremony, held at the Pokuase Palace, served as a celebration of the trainees' accomplishments and the project's overall success. It was a vibrant event that showcased the impressive creations of the participants and reinforced the importance of tackling plastic waste through community-driven solutions.</p>

                    <p>Media engagement played a significant role in amplifying the project's impact. Interviews were conducted with Channel 1 TV, Joy Prime, Joy News, Homebase TV, and Kessben TV, helping to spotlight the initiative’s objectives and achievements. The closing ceremony itself was covered by Homebase TV and Kessben TV, further extending the project's reach and influence.</p>

                    <p>This upcycling project provided both practical skills to its participants, and contributed to raising awareness about the importance of sustainable waste management practices. By empowering youth to take active roles in combating the plastic waste crisis, the project laid the groundwork for long-term environmental and economic benefits.</p>
            </>
        ),
          galleryImages: [yewImage1, yewImage2, yewImage3, yewImage4, yewImage5, yewImage6, yewImage7, yewImage8, yewImage9, yewImage10, yewImage11, yewImage12, yewImage13, yewImage18, yewImage19, yewImage20, yewImage21],
    },

    {
        id: 'green-ghana-day',
        title: 'Green Ghana Day Campaign',
        summary:
            'Mobilized volunteers nationwide to plant over 10,000 trees, supporting reforestation and environmental conservation.',
        details: (
            <>
                <p>In the spirit of environmental stewardship and community engagement, the Dziko Centre for Climate Justice proudly joined hands with volunteers nationwide to commemorate Green Ghana Day 2024. This annual event, dedicated to reforestation and environmental conservation, saw unprecedented enthusiasm and commitment from individuals across Ghana.
                </p>
                <p>With a collective vision of fostering a greener and more sustainable future, our team embarked on an ambitious mission: to plant over 10,000 trees nationwide. Armed with our tools and unwavering determination, volunteers from diverse backgrounds converged to contribute to Ghana's reforestation efforts.
                </p>From bustling urban centers to remote communities, the spirit of Green Ghana Day reverberated across the nation. Volunteers, young and old, urban dwellers and rural residents, came together as one cohesive force, united by a common purpose: to replenish our forests, protect our biodiversity, and combat climate change.
                <p>As we reflect on the success of Green Ghana Day 2024, we extend our heartfelt gratitude to every individual who contributed their time, energy, and passion to this noble cause. Your dedication and commitment have left an indelible mark on our environment and inspired countless others to join the fight for a greener Ghana.
                </p>As we celebrate the achievements of Green Ghana Day, we will not rest on our laurels. Our work is far from over. Together, we will continue to nurture the seeds of change we've planted, cultivating a legacy of environmental stewardship and sustainability for generations to come.
            </>
        ),
        galleryImages: [GGDImage11, GGDImage12,GGDImage13,GGDImage14,GGDImage15,GGDImage16,GGDImage17,GGDImage18,GGDImage19],
    },

    {
        id: 'climate-workshop-oyarifa',
        title: 'Climate Change Workshop at Divine Grace School, Oyarifa',
        summary:
            'Educating youth on climate change impacts and empowering them to lead climate action through thematic teams aligned with SDGs.',
        details: (
            <>
                <p>
                    Ghana, like many countries, grapples with the formidable impact of climate change. As temperatures rise, weather patterns become erratic, and ecosystems face unprecedented threats, the need for collective action and education has become paramount. Recognizing the urgency of this situation, we launched a workshop themed, "Rallying Youth for Climate Action".
                </p>Our project aimed to educate students about climate change and empower them to contribute as youth in mitigating its effects on human life. On Friday, 26th January 2024, we held our inaugural workshop at the Divine Grace School in Oyarifa, which left a lasting impact with enthusiastic engagement from both students and staff. Buoyed by this success, our young eco-warriors formed teams dedicated to specific climate action areas, contributing their efforts to Sustainable Development Goals (SDGs) related to climate resilience. These teams are ready to lead the charge in our community, supporting SDGs 13, 7, and 12 through the following focused missions:
                <p>
                    Team Reforestation (SDG 13) These relentless youth are all geared up to support reforestation efforts by planting more trees in our community and actively joining the campaign against the indiscriminate cutting of trees.
                </p>Team Cleaner Transportation (SDGs 11 and 13) This team is exploring greener sources of transport such as electric trains and buses. They are promoting eco-friendly transportation modes, including walking and cycling, to reduce dependence on conventional fuel vehicles, especially for short distances.
                <p>Team Waste Segregation and Life Below Water (SDG 14) Committed to sustainable waste management, this team is separating and recycling plastic waste to curb the pollution of our oceans, water bodies, and aquatic life. They showcased their resourcefulness by turning plastic waste into desirable items like aprons and side bags.
                </p>Team Cleaner Energy (SDG 7) These young eco-warriors aim to lead the charge in advocating for cleaner energy alternatives like solar and hydropower while campaigning against the use of fossil fuels.
                <p>eam Sustainability (SDG 12) This team is campaigning for sustainable practices such as water conservation to avoid wasting water and curb the overconsumption of resources.
                </p>In our subsequent meeting, the students eagerly shared their remarkable initiatives aimed at combating climate change. From innovative projects to creative solutions, each idea showed their dedication and commitment to safeguarding our planet. Some students showcased their handcrafted creations, turning plastic sachets into aprons, handbags, pencil cases, and other creative items. Their resourcefulness and ingenuity were truly inspiring.
                <p>Throughout the day, we witnessed the power of collaboration as students and staff worked together to address environmental challenges. Their enthusiasm was contagious, reminding us that collective action is key in the fight against climate change. Together, we are empowering these young eco-warriors to make a difference in their community and beyond.
                </p>As we continue on this journey, let us remember the words of Margaret Mead: "Never doubt that a small group of thoughtful, committed citizens can change the world; indeed, it's the only thing that ever has." Together, we can create a brighter, greener future for generations to come.
            </>
        ),
        galleryImages: [
   divineImage1, divineImage2, divineImage3, divineImage4, divineImage5, divineImage6, divineImage7,divineImage9
          , divineImage12, divineImage13, divineImage14, divineImage15, divineImage16, divineImage17, divineImage18,
            divineImage19, divineImage8, divineImage10],
    },
];

const Projects = () => {
    const [expandedProjectId, setExpandedProjectId] = useState(null);
    const [showHomeImage1, setShowHomeImage1] = useState(true);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    useEffect(() => {
        const interval = setInterval(() => {
            setShowHomeImage1((prev) => !prev);
        }, 3000);
        return () => clearInterval(interval);
    }, []);

    const toggleExpand = (id) => {
        setExpandedProjectId((prev) => (prev === id ? null : id));
    };

    return (
        <div>
            <Helmet>
                <title>Projects - Dziko Centre for Climate Justice</title>
                <meta name="description" content="Learn more about our projects and initiatives." />
                <meta property="og:title" content="Projects - Dziko Centre for Climate Justice" />
                <meta property="og:description" content="Explore our projects and initiatives." />
            </Helmet>
            <Navbar />

            <div className="bg-blue-700 py-4"></div>
            <section
                id="home"
                className="py-8 lg:w-3/5 mx-auto sm:w-60 px-6 mt-8"
            >
                <img
                    src={showHomeImage1 ? attentionGrabberImage1 : attentionGrabberImage2}
                    alt="Home Image"
                    className="rounded-md shadow-md"
                />
            </section>

            <main className="max-w-4xl mx-auto px-6 py-10">
                <h1 className="text-4xl font-extrabold mb-8 text-center">Our Climate Initiatives</h1>

                <p>At Dziko Centre for Climate Justice, we believe in empowering communities and youth
                    to lead the charge against climate change through innovation, education, and sustainable solutions.
                    Our projects span renewable energy, climate-smart agriculture, waste management, and community outreach,
                    all driven by technology and local engagement.</p>

                Explore how we turn challenges into opportunities for a greener, healthier, and more resilient Ghana.
                <div className="divide-y divide-gray-300">
                    {projectsData.map(({ id, title, summary, details, galleryImages }) => (
                        <section key={id} className="py-6 cursor-pointer">
                            <header
                                onClick={() => toggleExpand(id)}
                                className="flex justify-between items-center text-indigo-900 hover:text-indigo-600 transition-colors"
                                aria-expanded={expandedProjectId === id}
                                role="button"
                                tabIndex={0}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter' || e.key === ' ') toggleExpand(id);
                                }}
                            >
                                <h2 className="text-2xl font-semibold">{title}</h2>
                                <span className="text-3xl select-none">
                                    {expandedProjectId === id ? '−' : '+'}
                                </span>
                            </header>
                            {expandedProjectId === id && (
                                <div className="mt-4 text-gray-700 leading-relaxed">
                                    <p className="mb-6 font-semibold text-indigo-900 italic">{summary}</p>
                                    <div>{details}</div>
                                    {galleryImages && galleryImages.length > 0 && (
                                        <>
                                            <h3 className="text-xl font-bold mt-8 mb-4 text-indigo-900">Project Gallery</h3>
                                            <Gallery images={galleryImages} />
                                        </>
                                    )}
                                </div>
                            )}
                        </section>
                    ))}
                </div>
            </main>

            <Footer />
        </div>
    );
};

export default Projects;
